import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play-home",
  "use": "icon-play-home-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-play-home\"><path d=\"m23 16-12 7.5v-15L23 16Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol